<template>
  <div class="thumb portrait-image-box">
    <a
      href="javascript:void(0)"
      role="button"
      @click.prevent="$emit('on-click')"
    >
      <div class="image-box-wrapper">
        <div v-if="!isImageLoaded" class="image-alt-wrapper">
          <span>{{ imageAlt }}</span>
        </div>
        <img
          :src="imageUrl"
          class="thumb-img"
          :alt="imageAlt"
          :style="{
            display: isImageLoaded ? 'block' : 'none',
          }"
          @load="changeImageLoadedState(true)"
          @error="changeImageLoadedState(false)"
        />
      </div>
    </a>
  </div>
</template>
<script setup>
  import { computed, ref } from 'vue'
  import { resizeThumbnail } from '@/common/utils/image'
  const props = defineProps({
    cellInfo: {
      default: () => ({}),
      type: Object,
    },
    cellType: {
      type: String,
    },
    thumbnailInfo: {
      default: () => ({}),
      type: Object,
    },
  })

  const isImageLoaded = ref(false)

  const thumbnailImageUrl = computed(
    () => props.cellInfo?.logo_image || props.cellInfo?.thumbnail,
  )

  const imageAlt = computed(
    () => props.cellInfo?.alt || props.cellInfo?.logo_title || '이미지',
  )

  const imageUrl = computed(() => {
    const skeletonImage = props.thumbnailInfo?.placeholderImage || ''

    return !props.cellInfo
      ? skeletonImage
      : thumbnailImageUrl.value && thumbnailImageUrl.value !== ''
        ? resizeThumbnail(thumbnailImageUrl.value, {
            width: 180,
            height: 180,
            option: '20',
          })
        : null
  })

  const changeImageLoadedState = (value) => {
    isImageLoaded.value = value
  }
</script>

<style lang="scss" scoped>
  .portrait-image-box {
    width: 180px;
    height: 80px;
    .image-box-wrapper {
      width: 180px;
      height: 80px;
      position: relative;
      overflow: hidden;
      border-radius: 12px;
      background-color: #2f2f2f;
      img {
        width: 100%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .image-alt-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        span {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1; /* 라인수 */
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          font-size: 20px;
          color: #fff;
          text-align: center;
          line-height: 29px;
          white-space: inherit;
        }
      }
    }
  }
</style>
